import { WSQueryCache } from "@ws-react-query";
import { QUERY_NOTIFICATIONS_NOTIFICATIONS } from "./keys";
import { WSNotificationResponse } from "../../modules/Dashboard/components/Notifications";

export function removeNotificationFromCache(notificationId: string) {
  const notificationsCache = WSQueryCache.getQueryData<
    WSNotificationResponse[]
  >(QUERY_NOTIFICATIONS_NOTIFICATIONS);

  if (notificationsCache) {
    WSQueryCache.setQueryData(
      QUERY_NOTIFICATIONS_NOTIFICATIONS,
      notificationsCache.filter(
        notification => notification.notificationId !== notificationId
      )
    );
  }
}
